const Direction = ({ ...props }) => {
    return (
        <svg
            width="19"
            height="18"
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="icons" clipPath="url(#clip0_5245_2581)">
                <path
                    id="Vector 67"
                    d="M1.91421 7.58579L8.08579 1.41421C8.86683 0.633165 10.1332 0.633163 10.9142 1.41421L17.0858 7.58579C17.8668 8.36683 17.8668 9.63316 17.0858 10.4142L10.9142 16.5858C10.1332 17.3668 8.86684 17.3668 8.08579 16.5858L1.91421 10.4142C1.13317 9.63316 1.13316 8.36684 1.91421 7.58579Z"
                    stroke="black"
                    strokeWidth="0.954545"
                />
                <path
                    id="Rectangle 172"
                    d="M10.2875 5.63523L12.8417 8.18939L10.2875 10.7436"
                    stroke="black"
                />
                <path
                    id="Vector 68"
                    d="M12.8412 8.18939H6.84274V12.364"
                    stroke="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_5245_2581">
                    <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

export default Direction
